import Merge from 'deepmerge';

import flatten from './flatten';

let settings = {
  // Where are we showing adverts?
  country: 'NL',
  continent: 'EU',

  // How long should the jsonp requests wait
  // and when do we switch to our fallback
  timeout: 3000,

  // Where do we get our adverts?
  endpoint: {
    openx: '',
    fallback: '',
  },

  // And our adunit/display settings per region
  adunits: [],
};

// The actual configuration for OpenX ad units,
// the numbers here all have meaning so don't go
// changing things willy-nilly, billy.
export default {
  set(opts = {}) {
    if (opts.adunits) {
      opts.adunits = flatten(opts.adunits);
    }
    settings = Merge(settings, opts);
  },

  get(name) {
    if (!name) {
      return settings;
    }
    return settings[name];
  },
};
